import AskAction from './ask/Action'
import EndAction from './end/Action'
import ExitAction from './exit/Action'
import ErrorAction from './error/Action'
import LoadAction from './load/Action'
import LoaderAction from './loader/Action'
import RedirectAction from './redirect/Action'
import { ActionType, IAction } from './types'

export default function getActionComponent(action: IAction) {
  switch (action?.action) {
    case ActionType.ASK: {
      return AskAction
    }
    case ActionType.LOAD:
    case ActionType.GDPR: {
      return LoadAction
    }
    case ActionType.LOADER: {
      return LoaderAction
    }
    case ActionType.REDIRECT: {
      return RedirectAction
    }
    case ActionType.END: {
      return EndAction
    }
    case ActionType.EXIT: {
      return ExitAction
    }
    case ActionType.ERROR: {
      return ErrorAction
    }
    default: {
      return LoaderAction
    }
  }
}
